<template>
    <tbody>
        <tr v-for="(element, index) in elementList" :key="index">
            <td class="font-bold px-4 w-1/2">{{ element.name }}</td>
            <td class="w-16">{{ element.details }}</td>
            <td class="w-16">{{ element.quantity }} {{ element.unit }}</td>
        </tr>
    </tbody>
</template>

<script>

export default {
    name: 'ModuleMaterials',
    components: {
    },
    props: {
        module: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            bladeTickness: 3,
            topSpace: 50,
            bottomSpace: 50,
            moduleHeight: 0,
            moduleWidth: 0
        };
    },
    computed: {
        // TODO H150/20I over-counts here. This works out linear meters as count x full module
        // width, which is right for every model whose slats span the module - the width of a slat
        // does not change its length, so H60/100/20 and H150/20 are fine. H150/20I is not: its
        // 20 mm slats are short staggered segments, not full-width ones, so roughly half the slats
        // in the module are billed longer than they are. Needs a per-width length factor on the
        // model geometry (see slat_widths / min_gap on FenceModels) once we know the real length.
        slats() {
            let slatDimension = this.module.latime;

            if (this.module.tip === 'Panou') {
                slatDimension -= 2 * 8;
            }

            if (this.module.tip === 'Panou_rama') {
                slatDimension -= 2 * 3 + 2 * 70 + 2 * 8;
            }

            if (this.module.tip === 'Poarta_mica' || (this.module.tip === 'Poarta_mare' && (this.module.tip_poarta_mare === 'batanta_simpla' || this.module.tip_poarta_mare === 'batanta_dubla'))) {
                const leaf = this.module.tip_poarta_mare === 'batanta_dubla' ? 2 : 1;
                slatDimension -= leaf * (70 + 14 + 2 * 70 + 2 * 8 + 11); // 70 + 14 + 2 * 70 + 2 * 8 + 11 = post + hinge space + 2x frame + 2x profilU space + closure space
            }

            if (this.module.tip_poarta_mare === 'culisanta') {
                slatDimension += 500
                slatDimension -= 2 * 70 + 2 * 8;
            }

            if (this.module.tip_poarta_mare === 'autoportanta') {
                slatDimension += 300
                slatDimension -= 2 * 70 + 2 * 8;
            }

            return this.module.nr_profile * slatDimension / 1000;
        },
        frame() {
            if (this.module.tip === 'Panou') {
                return 0;
            } else {
                let moduleHeight = this.module.inaltime - this.topSpace - this.bottomSpace;
                let moduleWidth = this.module.latime;

                if (this.module.tip === 'Poarta_mica' || (this.module.tip === 'Poarta_mare' && (this.module.tip_poarta_mare === 'batanta_simpla' || this.module.tip_poarta_mare === 'batanta_dubla'))) {
                    const leaf = this.module.tip_poarta_mare === 'batanta_dubla' ? 2 : 1;
                    moduleWidth -= leaf * (70 + 14 + 11); // 70 + 14 + 11 = post + hinge space + closure space
                }

                if (this.module.tip_poarta_mare === 'culisanta') {
                    moduleWidth += 500
                }

                if (this.module.tip_poarta_mare === 'autoportanta') {
                    moduleWidth += 300
                }

                const verticalFrame = moduleHeight * 2
                const horizontalFrame = moduleWidth * 2
                return (verticalFrame + horizontalFrame) / 1000;
            }
        },
        reinforcement() {
            if (this.module.tip === 'Poarta_mare' && this.module.ranforsare) {
                let moduleHeight = this.module.inaltime - this.topSpace - this.bottomSpace;
                let moduleWidth = this.module.latime;


                if (this.module.tip_poarta_mare === 'batanta_simpla' || this.module.tip_poarta_mare === 'batanta_dubla') {
                    const leaf = this.module.tip_poarta_mare === 'batanta_dubla' ? 2 : 1;
                    moduleWidth -= leaf * (2 * 70 + 70 + 14 + 11);
                    return moduleWidth / 1000
                }

                if (this.module.tip_poarta_mare === 'culisanta' || this.module.tip_poarta_mare === 'autoportanta') {
                    moduleHeight -= 2 * 70;
                    return moduleHeight / 1000;
                }

                return 0

            } else {
                return 0;
            }
        },
        sidePosts() {
            if (this.module.tip === 'Poarta_mica' || (this.module.tip === 'Poarta_mare' && (this.module.tip_poarta_mare === 'batanta_simpla' || this.module.tip_poarta_mare === 'batanta_dubla'))) {
                const leaf = this.module.tip_poarta_mare === 'batanta_dubla' ? 2 : 1;
                return leaf * (this.module.inaltime - this.topSpace) / 1000;
            } else {
                return 0;
            }
        },
        profilU() {
            let uDimension = this.module.inaltime - this.topSpace - this.bottomSpace;
            let dual = 1

            const applicableModules = ['Panou_rama', 'Poarta_mica', 'Poarta_mare'];
            if (applicableModules.includes(this.module.tip)) {
                if (this.module.tip_poarta_mare === 'batanta_dubla' || this.module.tip_poarta_mare === 'culisanta' || this.module.tip_poarta_mare === 'autoportanta') {
                    dual = 2;
                }
                uDimension -= 2 * 70; // 2 * 8 = profilU space
            }

            return dual * 2 * uDimension / 1000;
        },
        profilT() {
            if (this.module.tip === 'Poarta_mica' || (this.module.tip === 'Poarta_mare' && (this.module.tip_poarta_mare === 'batanta_simpla' || this.module.tip_poarta_mare === 'batanta_dubla'))) {
                const leaf = this.module.tip_poarta_mare === 'batanta_dubla' ? 2 : 1;
                const ltDimension = leaf * this.module.inaltime - this.topSpace
                const tDimension = this.module.inaltime - this.topSpace - this.bottomSpace
                return (ltDimension + tDimension) / 1000
            } else {
                return 0;
            }
        },
        hingePuma() {
            if (this.module.tip === 'Poarta_mica') {
                return 2;
            } else {
                return 0;
            }
        },
        hingeDino() {
            if (this.module.tip === 'Poarta_mare' && (this.module.tip_poarta_mare === 'batanta_simpla' || this.module.tip_poarta_mare === 'batanta_dubla')) {
                const leaf = this.module.tip_poarta_mare === 'batanta_dubla' ? 2 : 1;
                return leaf * 2; // 2 hinges per leaf
            } else {
                return 0;
            }
        },
        rivets() {
            return this.module.nr_profile * 4;
        },
        rivetsPainted() {
            return 4
        },
        corners() {
            const applicableModules = ['Panou_rama', 'Poarta_mica', 'Poarta_mare'];
            if (applicableModules.includes(this.module.tip)) {
                let corners = 4;
                if (module.tip_poarta_mare === 'batanta_dubla') {
                    corners = corners * 2
                }
                return corners
            } else {
                return 0;
            }

        },
        ssScrew() {
            const cornerScrews = this.corners * 5
            return cornerScrews + 4
        },
        stopper() {
            if (this.module.tip === 'Poarta_mare' && this.module.tip_poarta_mare === 'batanta_dubla') {
                return 1;
            } else {
                return 0;
            }
        },
        latch() {
            if (this.module.tip === 'Poarta_mare' && this.module.tip_poarta_mare === 'batanta_dubla') {
                return 1;
            } else {
                return 0;
            }
        },
        mortice() {
            if (this.module.tip === 'Poarta_mica') {
                return 1;
            } else {
                return 0;
            }
        },
        cylinderLock() {
            if (this.module.tip === 'Poarta_mica') {
                return 1;
            } else {
                return 0;
            }
        },
        handle() {
            if (this.module.tip === 'Poarta_mica') {
                return 1;
            } else {
                return 0;
            }
        },
        moduleElements() {
            return [
                { name: 'Lamele', details: this.module.latime_profil + 'x18x1.5 mm', quantity: this.slats, unit: 'ml', price: '100' },
                { name: 'Rama', details: '70x40x3 mm', quantity: this.frame, unit: 'ml', price: '50' },
                { name: 'Ranforsare', details: '70x40x3 mm', quantity: this.reinforcement, unit: 'ml', price: '50' },
                { name: 'Stalpi laterali', details: '70x40x3 mm', quantity: this.sidePosts, unit: 'ml', price: '50' },
                { name: 'Profil U 25', details: '25x25x3 mm', quantity: this.profilU, unit: 'ml', price: '50' },
                { name: 'Profil U 32', details: '32x45x2.5 mm', quantity: this.profilU, unit: 'ml', price: '50' },
                { name: 'Profil T', details: '40x40x3 mm', quantity: this.profilT, unit: 'ml', price: '50' },
                { name: 'Coltare', details: '', quantity: this.corners, unit: 'buc', price: '50' },
                { name: 'Balamale PUMA', details: '', quantity: this.hingePuma, unit: 'buc', price: '50' },
                { name: 'Balamale DINO', details: '', quantity: this.hingeDino, unit: 'buc', price: '50' },
                { name: 'Suruburi inox', details: '6x16', quantity: this.ssScrew, unit: 'buc', price: '50' },
                { name: 'Popnituri', details: '', quantity: this.rivets, unit: 'buc', price: '50' },
                { name: 'Popnituri vopsite', details: '', quantity: this.rivetsPainted, unit: 'buc', price: '50' },
                { name: 'Opritor mecanic', details: '', quantity: this.stopper, unit: 'buc', price: '50' },
                { name: 'Zăvor', details: '', quantity: this.latch, unit: 'buc', price: '50' },
                { name: 'Mâner', details: '', quantity: this.handle, unit: 'buc', price: '50' },
                { name: 'Butuc (cilindru)', details: '', quantity: this.cylinderLock, unit: 'buc', price: '50' },
                { name: 'Broască', details: '', quantity: this.mortice, unit: 'buc', price: '50' },

            ];
        },
        elementList() {
            return this.moduleElements.filter(element => element.quantity > 0);
        }
    },
    methods: {

    },
    created() {
    }
}
</script>